import { AuditLogRepository, StaffActivityLog } from '../ports/AuditLogRepository';

export class CreateStaffActivityLogUseCase {
  constructor(private repository: AuditLogRepository) {}

  async execute(ownerId: string, log: StaffActivityLog): Promise<string> {
    if (!ownerId || !log.staffId) throw new Error('OwnerId and staffId are required');
    return await this.repository.createStaffActivityLog(ownerId, log);
  }
}
